<script lang="ts" setup>
import type { NewsletterSubscriptionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: NewsletterSubscriptionRecord }>();
</script>

<template>
  <div class="mb-4 font-bold">
    {{ data.title }}
  </div>
  <p class="mb-6" v-html="data.text" />
  <FormNewsletterSubscription :form="data" />
</template>

<style scoped>
</style>
